<!-- eslint-disable quotes -->
<!-- eslint-disable quotes -->
<template>
  <v-row justify="center">
    <v-dialog v-model="open" width="675px">
      <v-card>
        <v-toolbar elevation="0" color="background">
          <span class="pl-3 body-bold-medium">
            {{ $t('message.ai.quiz.editModal.question') }}
            {{ index > 0 ? index : '' }}
          </span>
          <v-spacer></v-spacer>
          <v-toolbar-items>
            <v-btn icon @click="handleClose">
              <v-icon>mdi-close</v-icon>
            </v-btn>
          </v-toolbar-items>
        </v-toolbar>
        <span class="mx-7 body-bold-smaller">{{
          $t('message.ai.quiz.editModal.questionTitle')
        }}</span>
        <br />
        <v-input
          v-if="!isEditingMode"
          v-model="selectedQuestion.enunciate"
          outlined
          class="mx-7"
          :placeholder="$t('message.ai.quiz.editModal.questionTitle')"
          hide-details
        ></v-input>
        <span class="mx-7 body-regular-small textType6--text" v-else>{{
          selectedQuestion.enunciate
        }}</span>
        <v-col cols="12" class="mt-2 px-0 pb-1">
          <v-divider />
        </v-col>
        <v-card-text class="px-2 py-0 pr-4">
          <div class="ml-3">
            <!-- <draggable
              v-model="selectedQuestion"
              group="question"
              @start="drag = true"
              @end="drag = false"
            > -->
            <v-col cols="12" class="pa-0">
              <v-row no-gutters>
                <v-card flat width="100%">
                  <v-col cols="12" class="pt-0">
                    <span class="d-flex">
                      <span
                        v-if="isEditingMode"
                        class="body-bold-medium mb-2 mt-5"
                        >{{
                          $t('message.ai.quiz.editModal.selectRightAnswer')
                        }}</span
                      >
                      <span v-else class="body-bold-medium mb-2 mt-5">{{
                        $t('message.ai.quiz.editModal.options')
                      }}</span>
                      <v-spacer></v-spacer>
                      <base-btn
                        v-if="!isEditingMode"
                        @click="isEditingMode = true"
                        class="mt-2"
                        style="align-self: center"
                        type="secondary"
                        size="xsmall"
                      >
                        {{ $t('message.ai.quiz.editModal.defineCorrect') }}
                      </base-btn>
                    </span>
                    <v-col cols="12" class="pa-0 mt-5">
                      <v-row
                        v-for="(option, index) in selectedQuestion.options"
                        :key="index"
                        no-gutters
                        class="mt-4"
                      >
                        <v-col v-if="isEditingMode" class="shrink">
                          <v-radio-group
                            v-model="questionCorrectIndex"
                            hide-details
                            @change="isEditingMode = false"
                            class="mt-0"
                          >
                            <v-radio class="mt-1" :value="index"></v-radio>
                          </v-radio-group>
                        </v-col>
                        <v-col
                          v-else
                          class="shrink d-flex align-self-center pr-2"
                        >
                          <v-img
                            src="@/assets/dragIcon.svg"
                            class="svgColor"
                            max-width="24"
                            contain
                          ></v-img>
                        </v-col>
                        <v-col class="d-flex align-self-center">
                          <v-input
                            v-show="!isEditingMode"
                            v-model="option.text"
                            :placeholder="
                              $t('message.ai.quiz.editModal.options')
                            "
                            style="max-width: 475px !important"
                            outlined
                            hide-details
                            dense
                          ></v-input>
                          <span v-show="isEditingMode" class="pt-2"
                            >{{ option.text }}
                          </span>
                          <v-col
                            cols="2"
                            class="d-flex align-self-center"
                            v-if="option.correct && !isEditingMode"
                          >
                            <v-tag type="success">{{
                              $t('message.ai.quiz.editModal.correct')
                            }}</v-tag>
                          </v-col>
                        </v-col>

                        <div v-if="!isEditingMode">
                          <v-tooltip
                            top
                            :disabled="selectedQuestion.options.length > 1"
                          >
                            <template v-slot:activator="{ on, attrs }">
                              <v-col
                                v-bind="attrs"
                                v-on="on"
                                class="shrink d-flex flex-row align-center justify-center px-0"
                              >
                                <v-icon
                                  :disabled="
                                    selectedQuestion.options.length < 2
                                  "
                                  size="20"
                                  style="cursor: pointer"
                                  @click="removeOption(index)"
                                >
                                  mdi-close
                                </v-icon>
                              </v-col>
                            </template>
                            <span>{{
                              $t('message.ai.quiz.editModal.minOptions')
                            }}</span>
                          </v-tooltip>
                        </div>
                        <!-- <v-icon
                            :disabled="selectedQuestion.options.length < 2"
                            size="20"
                            style="cursor: pointer"
                            @click="removeOption(index)"
                          >
                            mdi-close
                          </v-icon> -->
                      </v-row>
                      <!-- <base-btn
                        v-if="!isEditingMode"
                        :disabled="selectedQuestion.options.length > 4"
                        class="mt-5"
                        type="secondary"
                        @click="addOption"
                        ><v-icon size="20" class="mr-1"> mdi-plus </v-icon
                        >{{ $t('message.ai.quiz.addOption') }}</base-btn
                      > -->
                      <v-tooltip
                        :disabled="selectedQuestion.options.length <= 4"
                        top
                      >
                        <template v-slot:activator="{ on, attrs }">
                          <base-btn
                            v-bind="attrs"
                            v-on="on"
                            v-show="!isEditingMode"
                            :disabled="selectedQuestion.options.length > 4"
                            class="mt-5"
                            type="secondary"
                            @click="addOption"
                          >
                            <v-icon size="20" class="mr-1"> mdi-plus </v-icon>
                            {{ $t('message.ai.quiz.addOption') }}</base-btn
                          >
                        </template>
                        <span>{{
                          $t('message.ai.quiz.editModal.limitExceeded')
                        }}</span>
                      </v-tooltip>
                    </v-col>
                  </v-col>
                </v-card>
              </v-row>
            </v-col>
            <!-- </draggable> -->
          </div>
        </v-card-text>
        <!-- <v-col cols="12" class="pa-0 pl-8 mt-5 mb-6">
          <v-btn
            color="primary"
            class="elevation-0"
            @click="handleAddQuestion"
            >{{ $t('message.ai.quiz.addQuestion') }}</v-btn
          >
        </v-col> -->
        <v-col
          :style="
            isEditingMode ? 'opacity: 0 !important' : 'opacity: 1 !important'
          "
          cols="12"
          class="pa-0"
        >
          <v-divider />
        </v-col>
        <v-card-actions
          :style="
            isEditingMode ? 'opacity: 0 !important' : 'opacity: 1 !important'
          "
          class="px-8 py-6"
        >
          <v-spacer></v-spacer>
          <base-btn
            type="tertiary"
            class="elevation-0 mr-4 px-4"
            :disabled="checkIfHasChanged"
            @click="handleDiscardChanges"
          >
            {{ $t('message.pages.video.cancel') }}
          </base-btn>
          <v-tooltip bottom :disabled="!isSaveDisabled" :close-delay="500">
            <template v-slot:activator="{ on, attrs }">
              <div v-bind="attrs" v-on="on">
                <base-btn
                  type="primary"
                  :loading="loadings.updatingQuestions"
                  min-width="185px"
                  :disabled="isSaveDisabled"
                  @click="handleSaveQuestion"
                >
                  {{ $t('message.pages.video.publish') }}
                </base-btn>
              </div>
            </template>
            <span v-if="checkIfHasChanged">{{ $t('message.noChanges') }}</span>
            <div
              v-else
              class="align-center d-flex"
              style="pointer-events: all !important; width: 220px"
            >
              <div style="width: 194px">
                <span>
                  {{ $t('message.ai.quiz.editModal.defineOption') }}
                </span>
              </div>
              <div
                class="ml-2"
                style="width: 118px; z-index: 9999; cursor: pointer"
                cols="4"
              >
                <base-btn
                  @click.stop="isEditingMode = true"
                  type="neutral"
                  size="xsmall"
                >
                  {{ $t('message.ai.quiz.editModal.define') }}
                </base-btn>
              </div>
            </div>
          </v-tooltip>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </v-row>
</template>

<script>
import { mapMutations } from 'vuex'
import i18n from '@/translations/lang'
import aiworkflowApi from '@/services/aiworkflowApi'
import _ from 'lodash'
//import draggable from 'vuedraggable'

export default {
  name: 'VideoPlayerQuizModal',
  components: {
    //draggable,
  },
  data: () => ({
    open: false,
    questions: [],
    index: 0,
    isEditingMode: false,
    selectedQuestion: null,
    initialQuestionsVal: [],
    isEditing: false,
    beingEditedQuestion: {
      enunciate: '',
      options: [{ text: '', corrrect: true }],
    },
    question: { enunciate: '', options: [{ text: '', corrrect: true }] },
    questionCorrectIndex: 0,
    questionIndex: 0,
    loadings: {
      updatingQuestions: false,
    },
    expandedQuestionIndex: -1,
    drag: false,
  }),
  mounted() {
    this.isEditingMode = false
    this.$root.$on('openVideoQuizModal', (data) => {
      this.open = true
      this.isEditingMode = false
      this.selectedQuestion = _.cloneDeep(data.selectedQuestion)
      this.initialQuestionsVal = _.cloneDeep(data.questions)
      this.index = data.index
      this.questionCorrectIndex = this.selectedQuestion.options.findIndex(
        (option) => option.correct
      )

      // Garante que cada pergunta tenha um ID único
      this.initialQuestionsVal.forEach((q, index) => {
        if (!q.id) {
          q.id = `question-${index}-${Date.now()}`
        }
      })

      if (!this.selectedQuestion.id) {
        this.selectedQuestion.id = `question-${this.index}-${Date.now()}`
      }
    })
    this.$root.$on('addVideoQuizOption', (data) => {
      this.initialQuestionsVal = _.cloneDeep(data.questions)
      this.open = true
      this.handleAddQuestion()
    })
  },
  computed: {
    checkIfHasChanged() {
      if (!this.selectedQuestion || !this.initialQuestionsVal.length) {
        return true
      }
      const originalQuestion = this.initialQuestionsVal.find(
        (q) => q.id === this.selectedQuestion.id
      )
      if (!originalQuestion) return false
      return _.isEqual(this.selectedQuestion, originalQuestion)
    },

    isSaveDisabled() {
      return (
        this.checkIfHasChanged ||
        !this.selectedQuestion.options.some((option) => option.correct)
      )
    },
  },
  watch: {
    questionCorrectIndex() {
      if (!this.selectedQuestion || !this.selectedQuestion.options) return

      this.selectedQuestion.options.forEach((option) => {
        option.correct = false
      })

      const correctOption =
        this.selectedQuestion.options[this.questionCorrectIndex ?? 0]
      if (correctOption) correctOption.correct = true
    },
  },
  beforeDestroy() {},
  methods: {
    ...mapMutations('user', ['UPDATE_GLOBAL_SNACKBAR']),
    handleDiscardChanges() {
      const originalQuestion = this.initialQuestionsVal.find(
        (q) => q.enunciate === this.selectedQuestion.enunciate
      )
      if (originalQuestion) {
        this.selectedQuestion = _.cloneDeep(originalQuestion)
      }
      this.handleClose()
    },
    async updateQuestions() {
      const videoId = this.$route.params.id

      try {
        if (this.selectedQuestion) {
          const questionIndex = this.initialQuestionsVal.findIndex(
            (q) => q.id === this.selectedQuestion.id
          )

          if (questionIndex === -1) {
            this.initialQuestionsVal.push(this.selectedQuestion)
          } else {
            this.initialQuestionsVal[questionIndex] = this.selectedQuestion
          }
        }

        const aiData = {
          video_id: videoId,
          questions: this.initialQuestionsVal,
        }

        console.log('Enviando dados para API:', aiData)
        const res = await aiworkflowApi.updateAiWorkFlowData(aiData)
        this.initialQuestionsVal = res.data.questions
        this.$root.$emit('quizUpdateQuestions', this.initialQuestionsVal)

        this.handleClose()
      } catch (e) {
        console.error('Erro ao atualizar as questões:', e)
      }
    },
    async removeQuestion(indexToRemove) {
      const newArray = [
        ...this.questions.slice(0, indexToRemove),
        ...this.questions.slice(indexToRemove + 1),
      ]
      this.questions = newArray
    },
    addOption() {
      if (!this.selectedQuestion || !this.selectedQuestion.options) {
        console.error('A questão ou as opções estão indefinidas.')
        return
      }

      if (this.selectedQuestion.options.length >= 5) {
        console.warn('Não é possível adicionar mais de 5 opções.')
        return
      }

      this.selectedQuestion.options.push({
        text: '',
        correct: false,
      })
    },
    removeOption(optionIndex) {
      if (!this.selectedQuestion || !this.selectedQuestion.options) {
        console.error('A questão ou as opções estão indefinidas.')
        return
      }
      if (this.selectedQuestion.options.length < 2) {
        console.warn('Não é possível remover a última opção.')
        return
      }

      if (this.selectedQuestion.options[optionIndex].correct) {
        this.questionCorrectIndex = 0
      }

      this.selectedQuestion.options.splice(optionIndex, 1)
    },
    handleQuestion(question, index) {
      this.isUpdateQuestion = false
      this.questions[this.expandedQuestionIndex] = {
        enunciate: '',
        options: [{ text: '', corrrect: true }],
      }
      if (question?.enunciate) {
        this.initialEditingQuestionValue = question
        this.questions[this.expandedQuestionIndex] = question
        this.questionIndex = index
        this.isUpdateQuestion = true
      }
      this.isEditing = true
    },
    handleAddQuestion() {
      const newQuestion = {
        enunciate: '',
        options: [{ text: '', correct: true }],
      }
      this.selectedQuestion = newQuestion
      this.open = true
    },
    async handleSaveQuestion() {
      if (!this.selectedQuestion) {
        console.error('Nenhuma pergunta selecionada para salvar.')
        return
      }

      this.loadings.updatingQuestions = true

      try {
        // Encontrar a pergunta existente pelo ID
        const existingIndex = this.initialQuestionsVal.findIndex(
          (q) => q.id === this.selectedQuestion.id
        )

        if (existingIndex !== -1) {
          // Atualiza a pergunta existente
          this.initialQuestionsVal[existingIndex] = { ...this.selectedQuestion }
        } else {
          // Se não existir, adiciona como nova (caso o usuário tenha criado uma do zero)
          this.initialQuestionsVal.push(this.selectedQuestion)
        }

        await this.updateQuestions()
        this.UPDATE_GLOBAL_SNACKBAR({
          open: true,
          text: i18n.t('message.changesSaved'),
          type: 'success',
        })
      } catch (error) {
        console.error('Erro ao salvar a pergunta:', error)
        this.UPDATE_GLOBAL_SNACKBAR({
          open: true,
          text: i18n.t('message.errorOccurred'),
          type: 'error',
        })
      } finally {
        this.loadings.updatingQuestions = false
      }
    },
    handleClose() {
      this.$root.$emit('renameModalClosed')
      this.open = null
      this.isEditingMode = false
    },
  },
}
</script>

<style scoped>
.cardTitle {
  font-weight: 600;
  font-size: 24px;
  line-height: 36px;
}
.scroll-container {
  max-height: 400px;
  overflow-y: auto;
}
</style>

<style scoped lang="scss">
::v-deep input {
  font-size: 14px !important;
}

.v-toolbar__content {
  height: 50px !important;
}

.v-toolbar {
  height: 50px !important;
}

.bg-dark {
  .svgColor {
    filter: brightness(0) saturate(100%) invert(100%) sepia(59%) saturate(1451%)
      hue-rotate(179deg) brightness(86%) contrast(78%);
  }
}

::v-deep textarea {
  font-size: 14px !important;
}
</style>
